export const LineTypeEnum = Object.freeze({
    PACKAGE: 'package',
    SELECTED: 'selected',
    AVAILABLE: 'available',
});

export function isPackage(object) {
    return object.line_type === LineTypeEnum.PACKAGE;
}

export function isSelected(object) {
    return object.line_type === LineTypeEnum.SELECTED;
}

export function isAvailable(object) {
    return object.line_type === LineTypeEnum.AVAILABLE;
}

export const LineType = {
    isPackage,
    isSelected,
    isAvailable,
};

export const LineTypeMixin = {
    methods: {
        isPackage(object) {
            return isPackage(object);
        },
        isSelected(object) {
            return isSelected(object);
        },
        isAvailable(object) {
            return isAvailable(object);
        },
    },
};
